import React from 'react';
export function useHasMany(props) {
    const { records, keyBase, onChange, orderId } = props;
    const [showRecords, setShowRecords] = React.useState(records.length > 0 ? true : orderId ? false : null);
    const onUpdate = (recordToUpdate, name, value) => {
        onChange(records.map((record) => {
            if ((record.id && record.id === recordToUpdate.id) ||
                (record.key && record.key === recordToUpdate.key)) {
                return { ...record, [name]: value };
            }
            return record;
        }));
    };
    const onFieldUpdates = (recordToUpdate, fieldUpdates) => {
        onChange(records.map((record) => {
            if ((record.id && record.id === recordToUpdate.id) ||
                (record.key && record.key === recordToUpdate.key)) {
                return { ...record, ...fieldUpdates };
            }
            return record;
        }));
    };
    const buildNewRecord = () => {
        return { key: `new-${keyBase}-${records.length + 1}` };
    };
    const onAdd = () => {
        onChange(records.concat([buildNewRecord()]));
    };
    const onRemove = (recordToRemove) => {
        const newRecords = records.map((record) => {
            if ((record.id && record.id === recordToRemove.id) ||
                (record.key && record.key === recordToRemove.key)) {
                return { ...record, _destroy: true };
            }
            return record;
        });
        setShowRecords(newRecords.filter((r) => !r._destroy).length > 0);
        onChange(newRecords);
    };
    return {
        onUpdate,
        onFieldUpdates,
        onAdd,
        onRemove,
        showRecords,
        setShowRecords,
        buildNewRecord,
    };
}
